import {ReduxStateType} from '../store';

export const selectTaxReturnsReducer = (state: ReduxStateType) => {
  return {
    ...state.taxReturns,
    taxReturnsToBeFiled: state.taxReturns.taxReturns.filter(
      (ret) => ret.should_file_return,
    ),
  };
};